import WX_API from '@/utils/wx_api'
import Service from '@/service'
import subscribeProperties from '@/common/utils/watchProps'

let jscode

export default {
    set (userInfo) {
        WX_API.setStorage('userInfo', userInfo)
    }
}

export const GLOBAL_USER_DATA = subscribeProperties({}, [
    {
        key: 'weixin_phone_number',
        defaultValue: ''
    }
])

export const App_User = {
    init: false,
    userInfo: null,
    customerServiceInfo: null,
    officialCustomerService: null,
    customerServiceStaffLoading: false,
    _customerServiceCbs: [],
    _fetchCbs: [],
    share_by_consultant_uid: '',
    share_by: '',
    loading: false,
    setNickname (nickname) {
        this.userInfo.nickname = nickname
    },
    async isAuthed () {
        const userInfo = await App_User.get()
        return Boolean(userInfo.headimgurl)
    },
    setJscode (code) {
        jscode = code
    },
    getJscode () {
        return jscode
    },
    listenCustomerService (callback) {
        this._customerServiceCbs.push(callback)
    },
    setCustomerService (customerService) {
        while (this._customerServiceCbs.length) {
            const cb = this._customerServiceCbs.shift()
            if (typeof cb === 'function') {
                cb.call(this, customerService)
            }
        }
    },
    set (userInfo) {
        if (userInfo.subscribed_weixins && userInfo.subscribed_weixins.length) {
            userInfo.offical_weixin_subscribed = userInfo.subscribed_weixins.indexOf('成都购房通') > -1
            userInfo.weixin_subscribed = userInfo.subscribed_weixins.indexOf('成都购房者之家') > -1
            userInfo.consultant_weixin_subscribed = userInfo.subscribed_weixins.indexOf('置业顾问之家') > -1
        }
        this.userInfo = userInfo
        GLOBAL_USER_DATA.weixin_phone_number = userInfo.weixin_phone_number
        return userInfo
    },
    get () {
        const { userInfo } = this
        if (userInfo) {
            return Promise.resolve(userInfo)
        }
        return this.fetchUser()
    },
    addFetchCbs (res) {
        this._fetchCbs.push(res)
    },
    resolveFetchCbs (userinfo) {
        while (this._fetchCbs.length) {
            this._fetchCbs.shift()(userinfo)
        }
    },
    fetchUser () {
        if (this.loading) {
            return new Promise((res) => this.addFetchCbs(res))
        }
        this.loading = true
        return Service.getUserInfo().then((userinfo) => {
            this.resolveFetchCbs(userinfo)
            return this.set(userinfo)
        }).finally(() => {
            this.loading = false
        })
    },
    fetchCustomerServiceStaff (key) {
        if (this.customerServiceStaffLoading) {
            return new Promise((resolve) => {
                this.listenCustomerService(function(CustomerService) {
                    resolve(CustomerService[key] || {})
                })
            })
        }
        this.customerServiceStaffLoading = true
        return this.refreshCustomerServiceStaff().then((data) => {
            this.setCustomerService(data)
            return data[key] || {}
        })
    },
    getFromUserCache (key) {
        return this.get().then(userInfo => userInfo[key])
    },
    getFromUser (key) {
        return this.fetchUser().then(userInfo => userInfo[key])
    },
    refreshCustomerServiceStaff () {
        return Service.getCustomerServiceStaff().then((data) => {
            const { cunsultant_customer_service, official_customer_service } = data
            this.customerServiceInfo = cunsultant_customer_service
            this.officialCustomerService = official_customer_service
            this.customerServiceStaffLoading = false
            return data
        })
    },
    customer_service_info () {
        return this.fetchCustomerServiceStaff('cunsultant_customer_service')
    },
    official_customer_service () {
        const { officialCustomerService } = this
        if (officialCustomerService) {
            return Promise.resolve(officialCustomerService)
        }
        return this.fetchCustomerServiceStaff('official_customer_service')
    },
    is_consultant () {
        return this.getFromUser('is_consultant')
    },
    activity_menus () {
        return this.getFromUserCache('activity_menus') || []
    }
}
